<template lang="pug">
	.ai-music--song-lyrics-helper
		Popup(v-if="popupVisible", :popupVisible.sync="popupVisible", :title="title || $tCaption('Generate lyrics')", :autosize="true", :width="420", :showMaximize="true", :closeOnOutsideClick="false")
			.root
				StructureCriteria(ref="criteria", :service="songLyricsService", :hideCriteria="true", @change="(crt, pms, caps) => { params = pms; paramsCaptions = caps; }", 
					:valueResolver="$Data.externalServiceGetParamValue", :fullStructure="true", :hideHeaders="true", :autosize="true", :class="{ 'disabled-controls': isLoading }")
				Loader(v-if="isLoading", :text="$tCaption('Processing', '@actions') + (generatorStatus ? `: ${generatorStatus}` : '')", :fullscreen="true")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="popupVisible = false", :disabled="!!isLoading")
				DxButton(:text="$tCaption('Confirm', '@actions')", @click="process", type="success", :disabled="!!isLoading")
</template>

<script>
import DxButton from 'devextreme-vue/button';
import Popup from 'app-core/Popup.vue';
import StructureCriteria from 'view/webServiceCaller/StructureCriteria.vue';
import Loader from 'app-core/Loader.vue';
import { getValuesFromPropmtResponse } from './ai-music-helper';

export default {
	translationCategory: 'aiMusic.SongLyricsHelper',
	components: { DxButton, Popup, StructureCriteria, Loader },
	props: ['isBatch', 'instrumental', 'title'],
	data() {
		return {
			songLyricsService: null,
			popupVisible: false,
			params: {},
			paramsCaptions: {},
			isLoading: 0,
			generatorStatus: null,
			response: null
		};
	},
	computed: {
		
	},
	watch: {
		
	},
	mounted() {
		if (__DEBUG__)
			window.songLyricsHelper = this;
		
		this.loadSongLyricsService();
		this.$eventsBus.$on('signalr-on-notification', this.signalrOnNotification);
	},
	destroyed() {
		this.$eventsBus.$off('signalr-on-notification', this.signalrOnNotification);
	},
	methods: {
		signalrOnNotification({ eventName, data }) {
			if (eventName === 'AIScriptGenerator.Started') {
				this.generatorStatus = data.Name;
			}
		},
		async loadSongLyricsService() {
			if (this.songLyricsService) return;

			this.songLyricsService = await this.$Data.getExternalService('SongLyrics');
		},
		async show() {
			await this.loadSongLyricsService();

			this.popupVisible = false;
			this.$nextTick(() => this.popupVisible = true);
		},
		async process() {
			if (! (await this.$refs.criteria.validate())) {
				this.$notifyWarning(this.$tCaption('Please select a song'));
				return;
			}

			var params = Object.keys(this.params).filter(f => f && this.params[f]).map(f => ({
				Name: f,
				Value: this.params[f]
			}));
			
			this.generatorStatus = null;
			this.isLoading++;

			try {
				let r = await this.$Data.postExternalApi('ExternalService/RunExternalService', {
					ExternalServiceOid: this.songLyricsService.Oid,
					FormatResponse: !!this.songLyricsService.JsonDefinition.Outputs.length,
					Parameters: params,
					CalculateOutputs: this.isBatch || this.instrumental ? ['Title', 'Artist', 'Album', 'Text'] : []
				});

				if (r.Success === false) {
					this.$notifyError(r.ErrorMessage);
				} else {
					this.response = r?.Data;
					try {
						this.result = JSON.parse(this.response.FormattedResponse);
					} catch {
						this.result = null;
					}
					const aiOutput = r?.Data?.OutputResults?.find(f => f.Output?.Name === 'AI Genre');

					if (aiOutput) {
						if (__DEBUG__)
							console.debug('songLyricsHelper', { aiOutput });

						let values = getValuesFromPropmtResponse(aiOutput?.DisplayValue) || {};
						this.$emit('process', values);
					} else if (this.isBatch || this.instrumental) {
						this.$emit('process', {});
					}
				}
			} finally {
				this.isLoading--;
				this.popupVisible = false;
			}
		}
	}
};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";
	.ai-music--song-lyrics-helper {
		
	}
</style>
